import React from 'react';
import background from '../../assets/Deforestation_bg.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoDeforestation extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Deforestation"
        paragraph="Commercial agriculture is the largest driver of deforestation, followed by subsistence agriculture, mining, infrastructure, and urban expansion."
        coverbackground={background}
     />
  
  );
 }
}   

export default InfoDeforestation;